import { Component, OnInit } from '@angular/core';
import { AnnouncementService } from '../services/announcement.service';

@Component({
  selector: 'dac-announcement-bar',
  templateUrl: './announcement-bar.component.html',
  styleUrls: ['./announcement-bar.component.scss']
})
export class AnnouncementBarComponent implements OnInit {
  private _announcements:any[];

  constructor(private announcementService:AnnouncementService) { }

  ngOnInit() {
    // for now we are just going to grab a new announcement every time we come to the client list page.
    this.announcementService.getAnnouncements()
    .then((announcements) => {
      this._announcements = announcements.map(a => {
        a.alertClass = 'alert-' + a.type;
        return a;
      });
    })
    .catch(error => {
      console.error(error);
    });
  }

  public get Announcements() {
    return this._announcements;
  }

  public dismissAnnouncement(announcement:any) {
    this._announcements = this._announcements.filter(a => a !== announcement);
    this.announcementService.markAnnouncementRead(announcement); // even if it fails it will show up the next time and we take care of it on the server.
    
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/announcement-bar/announcement-bar.component.ts